	angular
	  .module('vppApp')
	  .service('SetLiveSwapService', SetLiveSwapService);

	SetLiveSwapService.$inject = ['$rootScope'];

	function SetLiveSwapService($rootScope) {
	  var lsInfoService = {};
	  $rootScope.LSBrandData = {};

	  var _createLSBrandObj = function(LSBrandInf) {
	    $rootScope.LSBrandData = {
	      LSBrand: LSBrandInf
	    };
	  };
	  // Recreate data Obj for page refresh
	  var _reCreateLSBrandObj = function(LSBrandInf) {
	    $rootScope.LSBrandData = {
	      LSBrand: LSBrandInf
	    };
	  };
	  lsInfoService.addLSBrand = function(LSBrandInf) {
	    // create userObj from success 
	    _createLSBrandObj(LSBrandInf);
	    // sets localStorage data
	    window.localStorage["vppDataLSBrand"] = angular.toJson($rootScope.LSBrandData);
	    // sets sessionStorage data
	    window.sessionStorage["vppDataLSBrand"] = angular.toJson($rootScope.LSBrandData);
	  };
	  lsInfoService.getLSBrandName = function() {
	    var _LSBrandCode = $rootScope.LSBrandData.LSBrand;
	    return _LSBrandCode;
	  };

	  lsInfoService.checkLSBrandExists = function() {

	    if (!Object.keys($rootScope.LSBrandData).length === 0) {
	      // $rootScope.vppDataLSBrand is Empty
	      var _tempSVNData = angular.fromJson(window.sessionStorage.getItem("vppDataLSBrand"));
	      var _tempLVNData = angular.fromJson(window.localStorage.getItem("vppDataLSBrand"));

	      if (_tempSVNData && _tempLVNData) {
	        _reCreateLSBrandObj(_tempLVNData.LSBrand);
	      }
	      // end
	    }

	  };
	  return lsInfoService;
	};
